module.exports = __webpack_public_path__ + "img/отобразить схему.7cbdf025.jpg";